/** @jsx jsx */
import { jsx } from '@emotion/core'

const PageNotFound = () => {
    return <h1>Page not found.</h1>
}

export { PageNotFound }
